export default "__VITE_ASSET__fffPQiST__"